// https://expertacademy.arlo.co/api/2012-02-01/pub/resources/eventtemplatesearch?fields=Categories,Name,ViewUri,TemplateID

import { getValidCategoryIDs } from "./lib";

export default async function getFilters() {
    try {
        let response = await fetch(`/api/arlo/fetch?data_type=eventtemplatesearch?fields=Categories,Name,ViewUri,TemplateID`, {
            method: 'GET',
        });

        if (!response.ok) {
            console.error(`HTTP error! status: ${response.status}`);
            return { success: false, error: `An error occurred. Status: ${response.status}` };
        } else {
            const data = await response.json();

            const uniqueCategories = new Map();

            // Loop through each item and its categories
            data.Items.forEach(item => {
                if (item.Categories) {
                    item.Categories.forEach(category => {
                        if (!uniqueCategories.has(category.CategoryID))
                            uniqueCategories.set(category.CategoryID, {...category, ...{'TemplateID': item.TemplateID}});
                    });
                }
            });

            const validCategories = getValidCategoryIDs();
            
            let uniqueCategoriesArray = Array.from(uniqueCategories.values());

            uniqueCategoriesArray = uniqueCategoriesArray.filter(category => validCategories.includes(category.CategoryID));

            uniqueCategoriesArray.sort((a, b) => {
                const nameA = a.Name.toLowerCase();
                const nameB = b.Name.toLowerCase();
                
                // If "all" is in the name, it gets higher priority
                const hasAllA = nameA.includes("all");
                const hasAllB = nameB.includes("all");
            
                if (hasAllA && !hasAllB) return -1;
                if (!hasAllA && hasAllB) return 1;

                return 0;
            });

            uniqueCategoriesArray.forEach((category, index) => {
                if (category.CategoryID === 1)
                    category.CategoryID = "[15,9,18,17]";

                category.ID = index;
            });

            return { success: true, data: uniqueCategoriesArray };
        }
    } catch (error) {
        console.error('Fetch error:', error);
        return { success: false, error: error.message };
    }
}